import { cn } from '../../lib/cn';
import { KpiCard } from '../ui';

type Props = {
  kpis?: { label: string; value: string; hint?: string }[];
  alerts?: { message: string; level: 'info' | 'warning' | 'error' }[];
  className?: string;
};

const DEFAULT_KPIS = [
  { label: 'Revenue (30d)', value: '$128.4K', hint: '+12% vs prior' },
  { label: 'ROAS', value: '5.8', hint: 'Portfolio avg' },
  { label: 'Health Score', value: '87', hint: 'Good' },
];

export function InsightPanel({
  kpis = DEFAULT_KPIS,
  alerts = [{ message: '3 campaigns budget-constrained', level: 'warning' as const }],
  className,
}: Props) {
  const alertColors = {
    info: 'border-info-200 bg-info-50 text-info-800 dark:border-info-900 dark:bg-info-950 dark:text-info-200',
    warning: 'border-warning-200 bg-warning-50 text-warning-800 dark:border-warning-900 dark:bg-warning-950 dark:text-warning-200',
    error: 'border-error-200 bg-error-50 text-error-800 dark:border-error-900 dark:bg-error-950 dark:text-error-200',
  };

  return (
    <div className={cn('space-y-3', className)}>
      <p className="text-xs font-semibold uppercase tracking-wide text-slate-500">Insights</p>
      {alerts.map((a, i) => (
        <div key={i} className={cn('rounded-lg border px-3 py-2 text-xs', alertColors[a.level])}>
          {a.message}
        </div>
      ))}
      <div className="space-y-2">
        {kpis.map((kpi) => (
          <KpiCard key={kpi.label} label={kpi.label} value={kpi.value} hint={kpi.hint} />
        ))}
      </div>
    </div>
  );
}
